// Level of role:
// System Admin > Digital Hands Admin > Digital Hands CSM > Customer Admin > Customer User.
// The smaller number, the higher level
export const MODULES = {
  HOME: {
    moduleName: 'Home',
  },
  TENANT_HOME: {
    moduleName: 'Tenant Home',
  },
  MY_CASES: {
    moduleName: 'My Cases',
  },
  DASHBOARDS_MITRE: {
    moduleName: 'MITRE ATT&CK Coverage',
  },
  DASHBOARDS_SIEM: {
    moduleName: 'CyGuard Cloud SIEM',
  },
  DASHBOARDS_EDR: {
    moduleName: 'CyGuard EDR',
  },
  DASHBOARDS_EDR_CROWDSTRIKE: {
    moduleName: 'CrowdStrike EDR',
  },
  CASES: {
    moduleName: 'Cases',
  },
  DASHBOARDS_VULNERABILITY: {
    moduleName: 'Vulnerability',
  },
  DASHBOARDS_CISO: {
    moduleName: 'CISO',
  },
  DASHBOARDS_PATCH_MANAGEMENT: {
    moduleName: 'Patch Management',
  },
  DASHBOARDS_PROMPT_AI: {
    moduleName: 'Prompt AI',
  },
  FILE_CENTER: {
    moduleName: 'File Center',
  },
  TENANT_FILE_CENTER: {
    moduleName: 'Tenant File Center',
  },
  ACTIVITIES: {
    moduleName: 'Activities',
  },
  SERVICES: {
    moduleName: 'Services',
  },
  MY_LINKS: {
    moduleName: 'My Links',
  },
  USER_MANAGEMENT: {
    moduleName: 'User Management',
  },
  INTERNAL_ADMIN: {
    moduleName: 'Internal Admin',
  },
  NOTIFICATION: {
    moduleName: 'Notification',
  },
  CONTACT_US: {
    moduleName: 'Contact Us',
  },
  AUDIT_LOGS: {
    moduleName: 'Audit Logs',
  },
  SECURITY_POSTURE: {
    moduleName: 'Security Posture',
  },
  PARTNER_LANDING_PAGE: {
    moduleName: 'Partner Landing Page',
  },
  ROLE_MANAGEMENT_PAGE: {
    moduleName: 'Role Management',
  },
  CHAT: {
    moduleName: 'Chat',
  },
  PDF_REPORTS: {
    moduleName: 'PDF Reports',
  },
};
